module.exports = __webpack_public_path__ + "static/img/2_6.8ae90822.jpg";